import { $bus } from "@/main";
import { ILayerControl, MapLayerGroup } from "@/types";
import { snakeCase } from "lodash-es";
import { useMap } from "@/services";

export class LayerControl implements ILayerControl {
  private _data = {} as ILayerControl;
  private _activeLayerId = "";
  constructor(data: ILayerControl | LayerControl) {
    if (data instanceof LayerControl) {
      return data;
    }
    Object.assign(this._data, data);
    if (this.isStyleLayer) {
      this.activeLayerId = (data.layerIds || [])[0] || "";
    } else {
      this.activeLayerId = data.id || "";
    }
  }

  get id() {
    return snakeCase(this._data.id);
  }

  get path() {
    return this._data.path;
  }

  get opacity() {
    return this.parentGroups.map((lg) => lg.opacity).reduce((a, b) => a * b, 1);
  }

  get isEditable(): boolean {
    return !!this._data.editable;
  }

  updateOpacity() {
    if (this._data.opacity !== this.opacity) {
      this._data.opacity = this.opacity;
      $bus.$emit("map:layers:updateLayer", this);
    }
  }

  get isVisible() {
    return this.parentGroups
      .map((lg) => lg.isVisible)
      .reduce((a, b) => a && b, true);
  }

  set isVisible(value: boolean) {
    useMap().updateLayerGroup({
      path: this.parentGroup?.path,
      key: "isVisible",
      value,
    });
  }

  updateVisibility() {
    if (this._data.isVisible !== this.isVisible) {
      this._data.isVisible = this.isVisible;
      $bus.$emit("map:layers:updateLayer", this);
    }
  }

  get parentGroups(): MapLayerGroup[] {
    return (useMap().layerGroups as MapLayerGroup[]).filter(
      (lg: MapLayerGroup) => this.path && this.path.indexOf(lg.path) > -1
    );
  }

  get parentGroup() {
    return this.parentGroups.find((lg) => lg.path === this.path);
  }

  get activeGroup(): MapLayerGroup | undefined {
    return this.isStyleLayer
      ? (useMap().layerGroups as MapLayerGroup[]).find((lg) =>
          lg.layers.includes(this.activeLayerId)
        )
      : this.parentGroup;
  }

  get layerIds() {
    return this.allLayerIds.filter((l) =>
      this.isStyleLayer ? l === this.activeLayerId : true
    );
  }

  get allLayerIds() {
    return this._data.layerIds || [this.id || ""];
  }

  get isStyleLayer() {
    return !!this._data.isStyleLayer;
  }

  get activeLayerId() {
    return this._activeLayerId;
  }

  set activeLayerId(val) {
    this._activeLayerId = val;
    $bus.$emit("map:layers:updateLayer", this);
  }
}
